/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
const useStyles = theme => ({
  faqContainerSuperMain: {
    background: theme?.palette?.primary?.backgroundColor3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '2rem',
  },
  toggleButtonsContainer: {
    background: theme?.palette?.secondary?.mobileToggleColor,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  containerToggle: {
    justifyContent: 'center',
    padding: '2rem 2.5rem 2.5rem 2.5rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 1rem 2rem 1rem',
    },
  },
  mobileOfferName: {
    color: theme?.palette?.secondary?.mobileInActiveToggleFontColor,
    textTransform: 'none',
    paddingLeft: '0.5rem',
    paddingRight: '0.25rem',
  },
  mobileOfferNameOne: {
    textTransform: 'lowercase',
    paddingRight: '0.5rem',
    color: theme?.palette?.secondary?.mobileActiveToggleBackground,
  },
  offerButtons: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& .MuiToggleButtonGroup-root': {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    '&.Mui-disabled': {
      border: 0,
    },
    '&.Mui-selected': {
      backgroundColor: theme?.palette?.primary?.offerMain,
      '&:hover': {
        backgroundColor: theme?.palette?.primary?.offerMain,
      },
      '& .MuiTypography-root': {
        color: theme?.palette?.secondary?.contrastText,
      },
    },
  },
});

export default useStyles;
